/* eslint-disable jsdoc/require-jsdoc */

import { fg } from '@atlaskit/platform-feature-flags/fg';

import { useAnnotationRangeState } from '../contexts/AnnotationRangeContext';

export type MarkDataAttributes = {
	dataAttributes?: {
		'data-renderer-start-pos': number;
	};
};

export function useInlineAnnotationProps(props: MarkDataAttributes):
	| {
			'data-annotation-draft-mark'?: undefined;
			'data-annotation-inline-node'?: undefined;
			'data-annotation-mark'?: undefined;
			'data-renderer-mark'?: undefined;
			'data-renderer-start-pos'?: undefined;
	  }
	| {
			'data-annotation-draft-mark': boolean;
			'data-annotation-inline-node': boolean;
			'data-annotation-mark'?: undefined;
			'data-renderer-mark': boolean;
			'data-renderer-start-pos': number;
	  }
	| {
			'data-annotation-draft-mark'?: undefined;
			'data-annotation-inline-node': boolean;
			'data-annotation-mark': boolean;
			'data-renderer-mark'?: undefined;
			'data-renderer-start-pos': number;
	  } {
	const { selectionDraftDocumentPosition: draftPosition } = useAnnotationRangeState();

	if (!fg('editor_inline_comments_on_inline_nodes')) {
		return {};
	}

	if (!props.dataAttributes) {
		// the inlineCard component is currently used by the block card, embed card and card error boundary components
		// when used via these components, no dataAttributes are passed (and we don't want it setup for inline comments)
		return {};
	}

	const inlineCardPosition = props.dataAttributes['data-renderer-start-pos'] - 1;

	const hasDraft =
		draftPosition &&
		// Ignored via go/ees005
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		draftPosition?.from <= inlineCardPosition! &&
		// Ignored via go/ees005
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		draftPosition?.to >= inlineCardPosition! + 1;

	if (hasDraft) {
		return {
			'data-renderer-mark': true,
			'data-annotation-draft-mark': true,
			'data-annotation-inline-node': true,
			'data-renderer-start-pos': inlineCardPosition,
		};
	}
	return {
		'data-annotation-inline-node': true,
		'data-annotation-mark': true,
		'data-renderer-start-pos': inlineCardPosition,
	};
}
